/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type CurrencySelector_user$ref = any;
type CurrencySelector_viewer$ref = any;
type LinkRow_viewer$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type Footer_viewer$ref: FragmentReference;
export type Footer_viewer = {|
  +isTradeExperienceEnabled: ?boolean,
  +isSellerDirectoryEnabled: ?boolean,
  +isSellerApplicationEnabled: ?boolean,
  +isAboutUsPageEnabled: ?boolean,
  +isCareersPageEnabled: ?boolean,
  +isPressPageEnabled: ?boolean,
  +isQuestionsPageEnabled: ?boolean,
  +isSiteMapsEnabled: ?boolean,
  +isDownloadAppEnabled: ?boolean,
  +user?: ?{|
    +serviceId: ?string,
    +$fragmentRefs: CurrencySelector_user$ref,
  |},
  +$fragmentRefs: CurrencySelector_viewer$ref & LinkRow_viewer$ref,
  +$refType: Footer_viewer$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "Footer_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "userId",
      "type": "String!"
    },
    {
      "kind": "RootArgument",
      "name": "hasUserId",
      "type": "Boolean"
    }
  ],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": "isQuestionsPageEnabled",
      "name": "isEnabledByLocale",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "QUESTIONS_PAGE",
          "type": "String!"
        }
      ],
      "storageKey": "isEnabledByLocale(featureName:\"QUESTIONS_PAGE\")"
    },
    {
      "kind": "ScalarField",
      "alias": "isTradeExperienceEnabled",
      "name": "isEnabledByLocale",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "TRADE_EXPERIENCE",
          "type": "String!"
        }
      ],
      "storageKey": "isEnabledByLocale(featureName:\"TRADE_EXPERIENCE\")"
    },
    {
      "kind": "ScalarField",
      "alias": "isSellerApplicationEnabled",
      "name": "isEnabledByLocale",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "SELLER_APPLICATION",
          "type": "String!"
        }
      ],
      "storageKey": "isEnabledByLocale(featureName:\"SELLER_APPLICATION\")"
    },
    {
      "kind": "ScalarField",
      "alias": "isAboutUsPageEnabled",
      "name": "isEnabledByLocale",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "ABOUT_US_PAGE",
          "type": "String!"
        }
      ],
      "storageKey": "isEnabledByLocale(featureName:\"ABOUT_US_PAGE\")"
    },
    {
      "kind": "ScalarField",
      "alias": "isCareersPageEnabled",
      "name": "isEnabledByLocale",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "CAREERS_PAGE",
          "type": "String!"
        }
      ],
      "storageKey": "isEnabledByLocale(featureName:\"CAREERS_PAGE\")"
    },
    {
      "kind": "ScalarField",
      "alias": "isPressPageEnabled",
      "name": "isEnabledByLocale",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "PRESS_PAGE",
          "type": "String!"
        }
      ],
      "storageKey": "isEnabledByLocale(featureName:\"PRESS_PAGE\")"
    },
    {
      "kind": "ScalarField",
      "alias": "isSellerDirectoryEnabled",
      "name": "isEnabledByLocale",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "SELLER_DIRECTORY",
          "type": "String!"
        }
      ],
      "storageKey": "isEnabledByLocale(featureName:\"SELLER_DIRECTORY\")"
    },
    {
      "kind": "ScalarField",
      "alias": "isSiteMapsEnabled",
      "name": "isEnabledByLocale",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "HTML_SITE_MAPS",
          "type": "String!"
        }
      ],
      "storageKey": "isEnabledByLocale(featureName:\"HTML_SITE_MAPS\")"
    },
    {
      "kind": "ScalarField",
      "alias": "isDownloadAppEnabled",
      "name": "isEnabledByLocale",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "DOWNLOAD_APP",
          "type": "String!"
        }
      ],
      "storageKey": "isEnabledByLocale(featureName:\"DOWNLOAD_APP\")"
    },
    {
      "kind": "FragmentSpread",
      "name": "CurrencySelector_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "LinkRow_viewer",
      "args": null
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "hasUserId",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "user",
          "storageKey": null,
          "args": [
            {
              "kind": "Variable",
              "name": "userId",
              "variableName": "userId",
              "type": "String!"
            }
          ],
          "concreteType": "User",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "serviceId",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "FragmentSpread",
              "name": "CurrencySelector_user",
              "args": null
            }
          ]
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'a6aef1ff25e349b54d865ce0605652e9';
module.exports = node;
